<template>
  <div id="app">
    <mheader v-if="showMobile" />
    <my-header v-if="showPC" />
    <router-view />

    <mfooter v-if="showMobile" />

    <MyFooter v-if="showPC"></MyFooter>
    <GoTop v-if="showPC"></GoTop>

    <div class="">
      <!-- pc -->
      <div class="mobile-code" v-if="showPC">
        <img src="./assets/image/home/mobile-code.png" alt="" />
      </div>
      <!-- 移动 -->
      <div class="mobile-code1" v-if="showMobile">
        <img src="./assets/image/home/mobile-code.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import Mfooter from "./components/Mfooter.vue";
import Mheader from "./components/Mheader.vue";
import MyHeader from "./components/MyHeader.vue";
export default {
  components: { MyHeader, Mfooter, Mheader },
  name: "App",
  data() {
    return {
      mywidth: 0,
      showMobile: false,
      showPC: true,
    };
  },
  mounted() {},
  created() {
    this.mywidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    if (this.mywidth < 768) {
      this.showMobile = true;
      this.showPC = false;
    }
    //vue生命周期创造时执行
    // var u = navigator.userAgent;
    // var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    // console.log('是否是Android：'+isAndroid);
    // console.log('是否是iOS：'+isiOS);
    // if()
    // /**兼容手机端1x、2x图样式*/
    // var html = document.documentElement;
    // html.style.fontSize= 100*(html.clientWidth / 750 )+'px';
    // document.body.style.fontSize = '16px';
    // /**兼容手机端1x、2x图样式*/
    // var docEl = document.documentElement,
    //   resizeEvt =
    //     "orientationchange" in window ? "orientationchange" : "resize",
    //   recalc = function () {
    //     var clientWidth = docEl.clientWidth;
    //     if (!clientWidth) return;
    //     let Zwidht = Math.floor(100 * (clientWidth / 750));
    //     if (Zwidht > 175) {
    //       Zwidht = 175;
    //     }
    //     if (isAndroid) {
    //       if (Zwidht < 100) {
    //         Zwidht = 100;
    //       }
    //     }
    //     docEl.style.fontSize = Zwidht + "px";
    //   };
    // if (!document.addEventListener) return;
    // window.addEventListener(resizeEvt, recalc, false);
    // document.addEventListener("DOMContentLoaded", recalc, false);
  },
  methods: {
    // htmlFontSize() {
    //   var h = Math.max(
    //     document.documentElement.clientHeight,
    //     window.innerHeight || 0
    //   );
    //   var w = Math.max(
    //     document.documentElement.clientWidth,
    //     window.innerWidth || 0
    //   );
    //   var width = w > h ? h : w;
    //   width = width > 720 ? 720 : width;
    //   var fz = ~~((width * 100000) / 36) / 10000;
    //   document.getElementsByTagName("html")[0].style.cssText =
    //     "font-size: " + fz + "px";
    //   var realfz =
    //     ~~(
    //       +window
    //         .getComputedStyle(document.getElementsByTagName("html")[0])
    //         .fontSize.replace("px", "") * 10000
    //     ) / 10000;
    //   if (fz !== realfz) {
    //     document.getElementsByTagName("html")[0].style.cssText =
    //       "font-size: " + fz * (fz / realfz) + "px";
    //   }
    // },
  },
};
</script>

<style lang="less">
.mobile-code1 {
  position: absolute;
  bottom: 19%;
  right: 0;
  width: (98 /3.75vw) !important;
  img {
    width: 100%;
  }
}
@media (min-width: 1980px) {
  .container-fluid {
    max-width: 1920px;
    width: 1920px;
    padding: 0;
  }
}
.container-fluid {
  padding: 0;
}
.mobile-code {
  width: 196px;
  height: 160px;
  position: fixed;
  right: 0;
  top: 600px;

  z-index: 999;
  border: none;
  cursor: pointer;
}
@media (max-width: 1400px) {
  .mobile-code {
    width: 120px !important;
    height: 98px !important;
    top: 50% !important;
  }
}
@media screen and (min-width: 1400px) and (max-width: 1980px) {
  /* @media (max-width: 1980px and max-width: 1980px) { */
  .mobile-code {
    width: 140px !important;
    /* height: 98px !important; */
    top: 60%;
  }
}
@media (min-width: 1980px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 1920px;
    width: 1920px;
    padding: 0;
  }
}
img {
  width: 100%;
}
a:hover {
  text-decoration: none;
}
.container {
  padding: 0;
}
bg-box {
  width: 100%;
}
@media (min-width: 576px) {
  bg-box {
    width: 540px;
  }
}
@media (min-width: 768px) {
  bg-box {
    width: 720px;
  }
}
@media (min-width: 992px) {
  bg-box {
    width: 960px;
  }
}
@media (min-width: 1200px) {
  bg-box {
    width: 1140px;
  }
}
@media (min-width: 1400px) {
  bg-box {
    width: 1320px;
  }
}
@media (min-width: 1980px) {
  bg-box {
    width: 1920px;
    height: 1080px;
  }
}

/* html {
  font-size: 1rem;
  20px 375
} */
/* html,
body {
  font-size: 62.5%;
  /* 1rem 10px */
/* } */

/* @media (min-width: 576px) {
  html {
    font-size: 1.25rem;
  }
}
@media (min-width: 768px) {
  html {
    font-size: 1.5rem;
  }
}
@media (min-width: 992px) {
  html {
    font-size: 1.75rem;
  }
}
@media (min-width: 1200px) {
  html {
    font-size: 2rem;
    
  }
} */
/* @media (min-width: 1400px) {
  html {
    font-size: 4rem;
  }
} */
/* @media (max-width: 1200px) {
  legend {
    font-size: calc(1.275rem + 0.3vw);
  }
  h1,
  .h1 {
    font-size: calc(1.375rem + 1.5vw);
  }
  h2,
  .h2 {
    font-size: calc(1.325rem + 0.9vw);
  }
  h3,
  .h3 {
    font-size: calc(1.3rem + 0.6vw);
  }
  h4,
  .h4 {
    font-size: calc(1.275rem + 0.3vw);
  }
  .display-1 {
    font-size: calc(1.725rem + 5.7vw);
  }
  .display-2 {
    font-size: calc(1.675rem + 5.1vw);
  }
  .display-3 {
    font-size: calc(1.575rem + 3.9vw);
  }
  .display-4 {
    font-size: calc(1.475rem + 2.7vw);
  }
  .close {
    font-size: calc(1.275rem + 0.3vw);
  } */
/* } */
</style>
